import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ContentActionComponent } from 'src/app/shared/content-action/content-action.component';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { Confirmation } from 'src/app/enums/confirmation.enum';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterFormModal, FilterValue } from 'src/app/models/form-group.model';
import { CommonService } from 'src/app/services/common.service';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import endpoints from 'src/app/helpers/endpoints';


@Component({
  selector: 'fury-global-ip-access-list',
  templateUrl: './global-ip-access-list.component.html',
  styleUrls: ['./global-ip-access-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class GlobalIpAccessListComponent implements OnInit, OnDestroy {

  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  @Input()
  columns = [
    {name: 'Ip Address', property: 'ipAddress', visible: true},
    { name: 'Actions', property: 'actions', visible: true },
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue = 'Global Ip Access';
  ngUnsubscribe = new Subject<void>();

  constructor(
    private apiservice: ApiService,
    private router: Router,
    public commonService: CommonService
  ) {
    
  }
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  ngOnInit(): void {
    this.router.onSameUrlNavigation = 'reload';
    this.getGlobalIpAddress();
  }

  ngAfterViewInit(): void {
    
  }
  getGlobalIpAddress() {
    this.apiservice
      .get(endpoints.globalIpAddress.getGlobalIpAddress)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: HttpResponse<any>) => {
        if(res.body){
          this.itemList = res.body?.globalAccessIps;
          this.dataSource = new MatTableDataSource(this.itemList);
        } else {
          this.itemList = undefined;
        }
      });
  }
  onFilterChange(value: any) {
    if (!this.dataSource) {return}
    value = value.trim();
    value = value.toLowerCase();
    this.dataSource.filter = value;
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
